import * as Tone from "tone"
import conv from "./resources/IR2.wav"
import conv2 from "./resources/hm2_000_ortf_48k.mp3"
import hit from "./resources/hit.wav"
let inst = {};
inst.templates = [
    {
        synth:
        {
            portamento: 0.5,
            oscillator: {
                type: "square4"
            }, envelope: {
                attack: 0.01,
                decay: 0.99,
                sustain: 0.5,
                release: 0.2
            }
        },
        volume: -20,
        freq: -24,
    },
    {
        synth:
        {
            oscillator: {
                type: "square4"
            }, envelope: {
                attack: 0.1,
                decay: 0.1,
                sustain: 0.1,
                release: 0.5
            }
        },
        volume: -20,
        freq: -24,

    },
    {
        synth:
        {
            oscillator: {
                type: "fatcustom",
                partials: [0.2, 1, 0, 0.5, 0.1],
                spread: 40,
                count: 3
            }, envelope: {
                attack: 0.001,
                decay: 1.6,
                sustain: 0,
                release: 1.6
            }
        },
        volume: -15,

    },
    {
        synth:
        {
            portamento: 0.1,
            oscillator: {
                partials: [
                    1,
                    0,
                    2,
                    0,
                    3
                ]
            }, envelope: {
                attack: 0.001,
                decay: 1.2,
                sustain: 0,
                release: 1.2
            }
        },
        volume: -20,

    },
    {
        synth:
        {
            portamento: 0,
            oscillator: {
                type: "fatcustom",
                partials: [0.2, 1, 0, 0.5, 0.1],
                spread: 40,
                count: 3
            }, envelope: {
                attack: 0.001,
                decay: 1.6,
                sustain: 0,
                release: 1.6
            }

        },
        volume: -15,
    }
]

let samples = [{
    'A2' : 'scale-A2.[mp3|ogg]',
    'A3' : 'scale-A3.[mp3|ogg]',
    'C3' : 'scale-C3.[mp3|ogg]',
    'C4' : 'scale-C4.[mp3|ogg]',
    'D3' : 'scale-C3.[mp3|ogg]',
    'D4' : 'scale-D4.[mp3|ogg]',
    'E3' : 'scale-E3.[mp3|ogg]',
    'E4' : 'scale-E4.[mp3|ogg]',
    'G2' : 'scale-G2.[mp3|ogg]',
    'G3' : 'scale-G3.[mp3|ogg]',
}, {
    'attack' : 0.01,
    'release' : 0.9,
    'baseUrl' : './teropa/'
}]

let pannerL1 = new Tone.Panner(-0.8).toDestination()
let pannerL2 = new Tone.Panner(-0.6).toDestination()
let pannerL3 = new Tone.Panner(-0.2).toDestination()
let pannerR1 = new Tone.Panner(0.8).toDestination()
let pannerR2 = new Tone.Panner(0.6).toDestination()
let pannerR3 = new Tone.Panner(0.2).toDestination()
let synthL = new Tone.Sampler(...samples)
let synthR = new Tone.Sampler(...samples)
synthL.connect(pannerL1)
synthL.connect(pannerL2)
synthL.connect(pannerL3)
synthR.connect(pannerR1)
synthR.connect(pannerR2)
synthR.connect(pannerR3)

inst.create = (i) => {
    let synth = i % 2 === 0 ? synthL : synthR
    synth.volume.value = -20;
    return synth;
}

export default inst

hit.wav